import type { BioscopeImageDay, BioscopeImageListQuery } from './types';

export function toBioscopeImageListQuery(
    selectedDay: string | undefined,
    permalinkImageId: string | undefined
): BioscopeImageListQuery | undefined {
    if (selectedDay) {
        return { day: selectedDay };
    }
    if (permalinkImageId) {
        return { imageId: permalinkImageId };
    }
    return undefined;
}

export function asArray<T>(value: unknown): T[] {
    return Array.isArray(value) ? (value as T[]) : [];
}

/**
 * Previous and next calendar days around the current selection.
 * When no day is selected, the last (latest) entry is the API default.
 */
export function neighbourDays(days: BioscopeImageDay[], selectedDay: string | undefined): string[] {
    if (days.length === 0) {
        return [];
    }
    const ordered = [...days].sort((a, b) => (a.day < b.day ? -1 : a.day > b.day ? 1 : 0));
    const current = selectedDay ?? ordered[ordered.length - 1]?.day;
    const index = ordered.findIndex((entry) => entry.day === current);
    if (index === -1) {
        return [];
    }
    const neighbours: string[] = [];
    if (index > 0) {
        neighbours.push(ordered[index - 1].day);
    }
    if (index < ordered.length - 1) {
        neighbours.push(ordered[index + 1].day);
    }
    return neighbours;
}
